var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { defineMessages, useIntl } from 'react-intl';
import Button from '@/shared/components/Button';
import { DeleteIcon } from '@/shared/components/Icons';
import YesNoModal from '@/shared/components/YesNoModal';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import SignalRService from '@/shared/services/SignalRService';
var messages = defineMessages({
    CompanyTeams: {
        id: 'CompanyTeams',
        defaultMessage: 'Company teams',
    },
    CompanyTeamsWarning: {
        id: 'CompanyTeamsWarning',
        defaultMessage: 'Changing the teams assigned to this company may affect access and visibility for users. Make sure the selection is correct before saving.',
    },
    AddTeam: {
        id: 'AddTeam',
        defaultMessage: 'Add a team',
    },
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    Remove: {
        id: 'Remove',
        defaultMessage: 'Remove',
    },
    ConfirmRemoveTeamTitle: {
        id: 'ConfirmRemoveTeamTitle',
        defaultMessage: 'Remove team',
    },
    ConfirmRemoveTeam: {
        id: 'ConfirmRemoveTeam',
        defaultMessage: 'Are you sure you want to remove the team "{name}" from this company?',
    },
    Close: {
        id: 'Close',
        defaultMessage: 'Close',
    },
    ApplyingTeamChanges: {
        id: 'ApplyingTeamChanges',
        defaultMessage: 'Applying the team change to the relations of this company, please wait...',
    },
});
// JobStatus: Initialized = 0, Processing = 1, Success = 2, Failed = 3, Skipped = 4
var JOB_FINISHED_MIN_STATUS = 2;
var RemoveIcon = DeleteIcon;
var CompanyTeamsModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, companyId = _a.companyId, teamItems = _a.teamItems, companyTeams = _a.companyTeams, onTeamsChanged = _a.onTeamsChanged;
    var intl = useIntl();
    var _b = useState(false), busy = _b[0], setBusy = _b[1];
    var _c = useState(null), pendingJobId = _c[0], setPendingJobId = _c[1];
    var _d = useState(null), teamToRemove = _d[0], setTeamToRemove = _d[1];
    var _e = useState(''), selectedTeamId = _e[0], setSelectedTeamId = _e[1];
    var pendingJobRef = useRef(null);
    var blocked = busy || pendingJobId != null;
    useEffect(function () {
        var handler = function (job) {
            if ((job === null || job === void 0 ? void 0 : job.id) === pendingJobRef.current && job.status >= JOB_FINISHED_MIN_STATUS) {
                pendingJobRef.current = null;
                setPendingJobId(null);
            }
        };
        SignalRService.subscribe('jobUpdated', handler);
        return function () { return SignalRService.unsubscribe('jobUpdated', handler); };
    }, []);
    var availableItems = teamItems.filter(function (t) { return !companyTeams.some(function (ct) { return ct.id === t.id; }); });
    var applyChange = function (newTeams, request) { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setBusy(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, request()];
                case 2:
                    data = (_a.sent()).data;
                    onTeamsChanged(newTeams, data.teamSecurityCode);
                    if ((data === null || data === void 0 ? void 0 : data.job) && data.job.status < JOB_FINISHED_MIN_STATUS) {
                        pendingJobRef.current = data.job.id;
                        setPendingJobId(data.job.id);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleHttpError(intl)(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAdd = function (teamId) {
        var item = teamItems.find(function (t) { return t.id === teamId; });
        if (!item)
            return;
        var newTeams = __spreadArray(__spreadArray([], companyTeams, true), [{ id: item.id, name: item.label, code: item.code }], false);
        applyChange(newTeams, function () {
            return api.base.post("/api/Team/AddCompanyTeam/".concat(companyId, "/").concat(teamId));
        });
        setSelectedTeamId('');
    };
    var handleRemove = function (teamId) { return __awaiter(void 0, void 0, void 0, function () {
        var newTeams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newTeams = companyTeams.filter(function (t) { return t.id !== teamId; });
                    return [4 /*yield*/, applyChange(newTeams, function () {
                            return api.base.delete("/api/Team/DeleteCompanyTeam/".concat(companyId, "/").concat(teamId));
                        })];
                case 1:
                    _a.sent();
                    setTeamToRemove(null);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Modal, __assign({ show: show, onHide: blocked ? function () { return undefined; } : onClose, backdrop: "static", keyboard: !blocked }, { children: [_jsx(Modal.Header, __assign({ closeButton: !blocked }, { children: _jsx(Modal.Title, { children: intl.formatMessage(messages.CompanyTeams) }) })), _jsxs(Modal.Body, { children: [_jsxs("div", __assign({ className: "input-group" }, { children: [_jsxs("select", __assign({ className: "form-control", value: selectedTeamId, onChange: function (e) { return setSelectedTeamId(e.target.value); }, disabled: blocked || availableItems.length === 0 }, { children: [_jsx("option", __assign({ value: "" }, { children: intl.formatMessage(messages.AddTeam) })), availableItems.map(function (item) { return (_jsx("option", __assign({ value: item.id }, { children: item.label }), item.id)); })] })), _jsx("span", __assign({ className: "input-group-btn" }, { children: _jsx(Button, __assign({ onClick: function () { return handleAdd(selectedTeamId); }, disabled: blocked || !selectedTeamId }, { children: intl.formatMessage(messages.Add) })) }))] })), pendingJobId != null && (_jsxs("p", __assign({ className: "help-block margin5T" }, { children: [_jsx("i", { className: "fa fa-spinner fa-spin margin5R" }), intl.formatMessage(messages.ApplyingTeamChanges)] }))), _jsx("div", __assign({ className: "margin20T" }, { children: _jsx("ul", __assign({ className: "list-unstyled" }, { children: companyTeams.map(function (team) { return (_jsxs("li", __assign({ className: "margin5B" }, { children: [_jsx("span", __assign({ className: "margin5R" }, { children: team.name })), !blocked && (_jsx(RemoveIcon, { tooltip: intl.formatMessage(messages.Remove), onClick: function () { return setTeamToRemove(team); }, style: { cursor: 'pointer' } }))] }), team.id)); }) })) })), _jsxs("p", __assign({ className: "help-block text-danger margin20T" }, { children: [_jsx("i", { className: "fa fa-exclamation-triangle margin5R" }), intl.formatMessage(messages.CompanyTeamsWarning)] }))] }), _jsx(Modal.Footer, { children: _jsx(Button, __assign({ onClick: onClose, disabled: blocked }, { children: intl.formatMessage(messages.Close) })) }), teamToRemove && (_jsx(YesNoModal, { show: true, title: intl.formatMessage(messages.ConfirmRemoveTeamTitle), message: intl.formatMessage(messages.ConfirmRemoveTeam, { name: teamToRemove.name }), onSave: function () { return handleRemove(teamToRemove.id); }, onNo: function () { return setTeamToRemove(null); }, onClose: function () { return setTeamToRemove(null); }, disabled: blocked }))] })));
};
export default CompanyTeamsModal;
